/** @module components/modals */
import React from "react";
import { cls } from "app/utils";
import { useAuth, useCalendly } from "app/utils/hooks";
import ModalWrapper from "app/components/modals/ModalWrapper";
// import config from "config/environment";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

type PropsDef = {
  isOpen: boolean;
  onClose: () => void;
};

const CALENDAR_URL =
  "https://coachnow.io/meetings/patrick665/coachnow-team-demos-2025?embed=true";

/**
 * @class CalendlyModal
 *
 */
export default function CalendlyModal({ isOpen, onClose }: PropsDef) {
  const { t } = useTranslation();
  const [user] = useAuth();
  const [showDone, setShowDone] = React.useState(false);
  const calendly = useCalendly();

  const closeModal = () => {
    if (onClose) {
      onClose();
    }
  };

  const onScheduled = () => {
    setShowDone(true);
  };

  React.useEffect(() => {
    if (calendly != null) {
      calendly.onEventScheduled(onScheduled);
      return () => calendly.clearEventScheduled(onScheduled);
    }
    return () => {};
  }, [calendly]);

  const setupCalendar = (parentElement: HTMLDivElement) => {
    if (calendly != null) {
      const prefill: { [key: string]: string } = {};
      if (user.data != null) {
        prefill.name = `${user.data.firstName} ${user.data.lastName}`;
        prefill.email = user.data.email;
      }

      if (parentElement != null) {
        calendly.initInlineWidget({
          // commented out an old calendly url
          // url: `https://calendly.com/${config.CALENDLY_LINK}?background_color=transparent`,
          url: CALENDAR_URL,
          parentElement,
          prefill,
        });
      }
    }
  };

  const setRef = (ref: HTMLDivElement) => {
    setupCalendar(ref);
  };

  return (
    <ModalWrapper
      className={styles.modal}
      containerClassName={styles.modalBody}
      headerClassName={styles.header}
      overlayClassName={styles.overlay}
      size="auto"
      title={t("Schedule A Demo")}
      isOpen={isOpen}
      onRequestClose={closeModal}
    >
      <div className={styles.calendlyModal}>
        <div className={styles.wrapper}>
          <div className={styles.container}>
            <div
              ref={setRef}
              className="calendly-inline-widget"
              // style={{ width: '100%'}} // , height: '100%' }}
              data-auto-load={false}
            ></div>
          </div>
        </div>

        <div
          className={cls(styles.buttons, showDone ? styles.done : styles.close)}
        >
          <button
            className={cls("btn btn-primary", styles.primary)}
            onClick={closeModal}
          >
            {t("Done")}
          </button>

          <button
            className={cls("btn btn-outline-secondary", styles.secondary)}
            onClick={closeModal}
          >
            {t("Close")}
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
}
